module.exports = __webpack_public_path__ + "static/media/arrow-up.d77d5fb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/arrow-up.svg
// module id = 922
// module chunks = 0